import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const MyBarChart = ({ style, data }) => (
    <div>
        <BarChart width={style.width} height={style.height} data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="pv" stackId="a" fill="#8884d8" />
            <Bar dataKey="uv" stackId="a" fill="#82ca9d" />
        </BarChart>
    </div>
);

MyBarChart.defaultProps = {
    style: {
        width: 330,
        height: 150
    },
    data: []
};

export default MyBarChart;


// WEBPACK FOOTER //
// ./src/components/charts/MyBarChart.js